import {ChangeDetectionStrategy, Component, HostBinding, Input} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-fixture",
    styleUrls: ["./fixture.component.scss"],
    templateUrl: "./fixture.component.html",
    standalone: false
})
export class FUIFixtureComponent {
    @Input() @HostBinding("class.wrappable") public wrappable: boolean;
}
